import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Tooltip from '@mui/material/Tooltip';
import Cancel from '@mui/icons-material/Cancel';

export default function UsgsLegend(props) {
    const { mapType, mapDate, cagType } = props;
    const [ showModal, setShowModal ] = useState(false);

    const legend_defs = {
        groundwater: {
          "href1": "https://waterdata.usgs.gov/nwis/gw",
          "text1": "USGS Groundwater",
          "href2": null,
          "text2": null,
          "title": "Percentile Categories"
        }, 
        streamflow: {
          "href1": "https://waterwatch.usgs.gov",
          "text1": "USGS WaterWatch",
          "href2": "https://waterwatch.usgs.gov/index.php?id=ww_current",
          "text2": "Streamflow",
          "title": "Percentile Categories"
        }
    };

    const href1 = legend_defs[mapType]["href1"];
    const text1 = legend_defs[mapType]["text1"];
    const href2 = legend_defs[mapType]["href2"];
    const text2 = legend_defs[mapType]["text2"];
    const title = legend_defs[mapType]["title"];
    
    const handleOpenModal = (e) => {
        setShowModal(e);
    }
    
    const handleCloseModal = () => {
        setShowModal(false);
    }

    return (
      <div>
        {mapType === 'streamflow' &&
          <table className="mapLegend-container">
            <thead>
              <tr>
                <th colSpan="12">{title}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="mapLegend-box-container"><div className="mapLegend-icon mapLegend-icon-red"></div></td>
                <td className="mapLegend-box-container"><div className="mapLegend-icon mapLegend-icon-darkred"></div></td>
                <td className="mapLegend-box-container"><div className="mapLegend-icon mapLegend-icon-darkorange"></div></td>
                <td className="mapLegend-box-container"><div className="mapLegend-icon mapLegend-icon-lime"></div></td>
                <td className="mapLegend-box-container"><div className="mapLegend-icon mapLegend-icon-lightblue"></div></td>
                <td className="mapLegend-box-container"><div className="mapLegend-icon mapLegend-icon-blue"></div></td>
                <td className="mapLegend-box-container"><div className="mapLegend-icon mapLegend-icon-black"></div></td>
              </tr>
              <tr>
                <td className="mapLegend-box-container" rowSpan="2">Low</td>
                <td className="mapLegend-box-container">Much below normal</td>
                <td className="mapLegend-box-container">Below normal</td>
                <td className="mapLegend-box-container">Normal</td>
                <td className="mapLegend-box-container">Above normal</td>
                <td className="mapLegend-box-container">Much above normal</td>
                <td className="mapLegend-box-container" rowSpan="2">High</td>
              </tr>
              <tr>
                <td className="mapLegend-box-container">&lt;10%</td>
                <td className="mapLegend-box-container">10-24%</td>
                <td className="mapLegend-box-container">25-75%</td>
                <td className="mapLegend-box-container">76-90%</td>
                <td className="mapLegend-box-container">&gt;90%</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="7">Data provided by <a href={href1} target="_blank" rel="noreferrer">{text1}</a> | <a href={href2} target="_blank" rel="noreferrer">{text2}</a> | updated {mapDate}</td>
              </tr>
            </tfoot>
          </table>
        }

        {/* {(mapType === 'groundwater' && cagType === 'usgs') &&
          <table className="mapLegend-container">
            <thead>
              <tr>
                <td colSpan="7"><span style={{fontWeight:"bold"}}>Explanation - Percentile Classes</span></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><div className="mapLegend-icon mapLegend-icon-red"></div></td>
                <td><div className="mapLegend-icon mapLegend-icon-darkred"></div></td>
                <td><div className="mapLegend-icon mapLegend-icon-darkorange"></div></td>
                <td><div className="mapLegend-icon mapLegend-icon-lime"></div></td>
                <td><div className="mapLegend-icon mapLegend-icon-lightblue"></div></td>
                <td><div className="mapLegend-icon mapLegend-icon-blue"></div></td>
                <td><div className="mapLegend-icon mapLegend-icon-black"></div></td>
              </tr>
              <tr>
                <td rowSpan="2">Low</td>
                <td>Much below normal</td>
                <td>Below normal</td>
                <td>Normal</td>
                <td>Above normal</td>
                <td>Much above normal</td>
                <td rowSpan="2">High</td>
              </tr>
              <tr>
                <td>&lt;10%</td>
                <td>10-24%</td>
                <td>25-75%</td>
                <td>76-90%</td>
                <td>&gt;90%</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="7">Data provided by <a href={href1} target="_blank" rel="noreferrer">{text1}</a> | <button className="mapLegend-button" onClick={() =>handleOpenModal('gw')}>About this map</button> | updated {mapDate}.</td>
              </tr>
            </tfoot>
          </table>
        } */}

        {(mapType === 'groundwater' && cagType === 'usdm') &&
            <table className="mapLegend-container" summary="Legend for point value markers on map">
                <tbody>
                    <tr>
                        <th colSpan="12">{title}</th>
                    </tr>
                    <tr>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d4"></div></td>
                        <td><b>D4</b>: &lt;2%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d3"></div></td>
                        <td><b>D3</b>: 2-5%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d2"></div></td>
                        <td><b>D2</b>: 5-10%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d1"></div></td>
                        <td><b>D1</b>: 10-20%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-d0"></div></td>
                        <td><b>D0</b>: 20-30%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-dnada"></div></td>
                        <td>30-70%</td>
                    </tr>
                    <tr>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w0"></div></td>
                        <td><b>W0</b>: 70-80%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w1"></div></td>
                        <td><b>W1</b>: 80-90%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w2"></div></td>
                        <td><b>W2</b>: 90-95%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w3"></div></td>
                        <td><b>W3</b>: 95-98%</td>
                        <td className="mapLegend-icon-container"><div className="mapLegend-icon mapLegend-icon-w4"></div></td>
                        <td><b>W4</b>: &gt;98%</td>
                        <td className="mapLegend-icon-container"><div></div></td>
                        <td></td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="12">Data provided by <a href={href1} target="_blank" rel="noreferrer">{text1}</a> | <button className="mapLegend-button" onClick={() =>handleOpenModal('gw')}>About this map</button> | updated {mapDate}</td>
                    </tr>
                </tfoot>
            </table>
        }

        <Modal 
          open={showModal === 'gw' || showModal === 'sf'}
          onClose={handleCloseModal} 
          className="modal-container-container"
          >
          <div className="modal-container">
            <Tooltip title="Close">
              <Cancel onClick={handleCloseModal} />
            </Tooltip>
            {showModal === 'gw' &&
              <React.Fragment>
                <h2>Groundwater Status Map</h2>
                <p>
                  This map is based on observations retrieved from the <a href="https://waterservices.usgs.gov/rest/DV-Service.html" target="blank">USGS Daily Values Site Web Service</a> and <a href="https://waterservices.usgs.gov/rest/GW-Levels-Service.html" target="blank" rel="noreferrer">USGS Groundwater Levels Web Service</a>. 
                  Data include approved, quality-assured data, and more recent provisional data, whose accuracy has not been verified by USGS. USGS data are provided 
                  to meet the need for timely best science and on the condition that neither the USGS nor the U.S. Government shall be held liable for any damages 
                  resulting from the authorized or unauthorized use of the data. 
                </p>
                <p >
                  Station percentile values used in this map were computed by NRCC. They are based on the historical data occurring within a 31-day window centered on the date of interest 
                  and filtered down to just the measurement taken closest to the date of interest for each year. These percentile values, therefore, may differ from those available from 
                  other sources, where other methods of percentile computation may have been employed.
                </p>
              </React.Fragment>
            }
            {/* {showModal === 'sf' &&
              <React.Fragment>
                <h2>Streamflow Status Map</h2>
                <p>
                  This map is based on observations retrieved from the <a href="https://waterservices.usgs.gov/rest/DV-Service.html" target="blank" rel="noreferrer">USGS Daily Values Site Web Service</a>. 
                  Data include approved, quality-assured data, and more recent provisional data, whose accuracy has not been verified by USGS. USGS data are provided 
                  to meet the need for timely best science and on the condition that neither the USGS nor the U.S. Government shall be held liable for any damages 
                  resulting from the authorized or unauthorized use of the data. 
                </p>
                <p >
                  Station percentile values plotted on this map were computed by NRCC. They are based on the historical data occurring within 1-, 7-, 14-, and 28-day windows ending on the date of interest 
                  and summarized as the median value for the period for each year. Percentiles were computed for stations with at least 20 years of historical data. These percentile values may differ from those available from 
                  other sources.
                </p>
              </React.Fragment>
            } */}
          </div>
        </Modal>
      </div>
    )
}
